var windowWidth = $(window).width();

$(window).resize(function () {
    windowWidth = $(window).width();
});

if ($('#vehicle_brands_page').data('range') === "CAR") {
    cookies.set("vt", "Cars", 30);
} else {
    cookies.set("vt", "Vans", 30);
}

function swapPaymentTypes(pricingType) {
    if (pricingType === 'Personal') {
        $('.personal_button').removeClass('btn-filter-inactive').addClass('is-active');
        $('.business_button').removeClass('is-active').addClass('btn-filter-inactive');
        $('.lowest-Price-Business').hide();
        $('.lowest-Price-Personal').show();
    }
    else if (pricingType === 'Business') {
        $('.business_button').removeClass('btn-filter-inactive').addClass('is-active');
        $('.personal_button').removeClass('is-active').addClass('btn-filter-inactive');
        $('.lowest-Price-Personal').hide();
        $('.lowest-Price-Business').show();
    }
};

$(document).ready(function () {
    $(document).on('click', '.business_button.pt-cookie',
        function (e) {
            $('.js-options-loader').fadeIn();
            var form = $("#pricing-filter-form");
            $.ajax(
                {
                    url: form.attr('action'),
                    data: form.serialize() + "&PricingType=Business",
                    type: "GET",
                    success: function (data) {
                        $('.lowest-Price-Personal').hide();
                        $('.lowest-Price-Business').show();
                        $("#vehicle-results").html(data);
                        $('.business_button.pt-cookie').removeClass('btn-filter-inactive').addClass('is-active');
                        $('.personal_button.pt-cookie').removeClass('is-active').addClass('btn-filter-inactive');
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', '.personal_button.pt-cookie',
        function (e) {
            $('.js-options-loader').fadeIn();
            var form = $("#pricing-filter-form");
            $.ajax(
                {
                    url: form.attr('action'),
                    data: form.serialize() + "&PricingType=Personal",
                    type: "GET",
                    success: function (data) {
                        $('.lowest-Price-Business').hide();
                        $('.lowest-Price-Personal').show();
                        $("#vehicle-results").html(data);
                        $('.personal_button.pt-cookie').removeClass('btn-filter-inactive').addClass('is-active');
                        $('.business_button.pt-cookie').removeClass('is-active').addClass('btn-filter-inactive');
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', ".js-clear-filters, .js-clear-body-type",
        function (e) {
            $('.js-options-loader').fadeIn();

            e.preventDefault();
            var form = $("#pricing-filter-form");
            var pricingType = $('.pt-cookie.is-active').html();
            
            var dataSent = "?PricingType=" + pricingType + "&SortBy=" + $('#order_by_desktop').val();
            if (windowWidth <= 1216 && $("#pricing-filter-form-mobile:visible").length > 0) {
                form = $("#pricing-filter-form-mobile");
                dataSent = "?PricingType=" + pricingType + "&SortBy=" + $('#order_by_desktop').val() + "&PopoutActive=true";
            }

            $.ajax(
                {
                    url: form.attr('action'),
                    data: dataSent,
                    type: "GET",
                    success: function (data) {
                        $("#vehicle-results").html(data);

                        $('form input:radio').prop('checked', false);
                        $('form input:checkbox').prop('checked', false);
                        $('form label').removeClass('checked', false);
                        $('#filter-preview-body').text();
                        $('#filter-preview-model').text();
                        $('#filter-preview-fuel').text();
                        $('#filter-preview-transmission').text();
                        $('#filter-preview-drive').text();

                        swapPaymentTypes(pricingType);

                        $("html, body").animate({
                            scrollTop: $('#vehicle-container').offset().top - 75
                        }, 200);

                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', 'form input:radio, form input:checkbox',
        function (e) {

            $(this).parent('label').siblings('label').removeClass('checked');
            $(this).parent('label').addClass('checked');
            $(this).addClass('checked');

            $('.js-options-loader').fadeIn();

            var bodyType = $('.js-filter-radio[name="bodyType"]:checked').val();
            var specLevel = $('.js-filter-radio[name="specLevel"]:checked').val();
            var fuelType = $('.js-filter-radio[name="fuelType"]:checked').val();
            var transmission = $('.js-filter-radio[name="transmission"]:checked').val();
            var drive = $('.js-filter-radio[name="drive"]:checked').val();
            var pricingType = $('.pt-cookie.is-active').html();

            var form = $("#pricing-filter-form");
            var dataSent = (form.serialize() !== "" && form.serialize() !== "?" ? form.serialize() + "&PricingType=" : "?PricingType=") + pricingType + "&SortBy=" + $('#order_by_desktop').val();
            if (windowWidth <= 1216 && $("#pricing-filter-form-mobile:visible").length > 0) {
                form = $("#pricing-filter-form-mobile");
                $('#vehicle_brands_page').removeClass((function (index, className) {
                    return (className.match(/(^|\s)popout-popout-filter-\S+/g) || []).join(' ');
                }));
                dataSent = {
                    "BodyType": bodyType,
                    "SpecLevel": specLevel,
                    "FuelType": fuelType,
                    "Transmission": transmission,
                    "Drive": drive,
                    "PricingType": pricingType,
                    "Page": 1,
                    "SortBy": $('#order_by_mobile').val(),
                    "PopoutActive": true
                };
            }

            $.ajax(
                {
                    url: form.attr('action'),
                    data: dataSent,
                    type: "GET",
                    success: function (data) {
                        $("#vehicle-results").html(data);
                        swapPaymentTypes(pricingType);
                        if (bodyType !== undefined && bodyType.length > 0) { $('.filter-preview-options#filter-preview-body').text(bodyType); }
                        if (specLevel !== undefined && specLevel.length > 0) { $('.filter-preview-options#filter-preview-model').text(specLevel); }
                        if (fuelType !== undefined && fuelType.length > 0) { $('.filter-preview-options#filter-preview-fuel').text(fuelType); }
                        if (transmission !== undefined && transmission.length > 0) { $('.filter-preview-options#filter-preview-transmission').text(transmission); }
                        if (drive !== undefined && drive.length > 0) { $('.filter-preview-options#filter-preview-drive').text((drive === "1" ? "4WD" : "2WD")); }

                        $("html, body").animate({
                            scrollTop: $('#vehicle-container').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('change', '#order_by_mobile',
        function (e) {
            $('.js-options-loader').fadeIn();
            var sort = $(this).val();
            var form = $("#pricing-filter-form-mobile");
            var pricingType = $('.pt-cookie.is-active').html();
            $.ajax(
                {
                    url: form.attr('action'),
                    data: {
                        "BodyType": $('.js-filter-radio[name="bodyType"]:checked').val(),
                        "SpecLevel": $('.js-filter-radio[name="specLevel"]:checked').val(),
                        "FuelType": $('.js-filter-radio[name="fuelType"]:checked').val(),
                        "Transmission": $('.js-filter-radio[name="transmission"]:checked').val(),
                        "Drive": $('.js-filter-radio[name="drive"]:checked').val(),
                        "PricingType": pricingType,
                        "Page": 1,
                        "SortBy": sort
                    },
                    type: "GET",
                    success: function (data) {
                        $("#vehicle-results").html(data);
                        swapPaymentTypes(pricingType);
                        $('#order_by_mobile-header').val(sort);
                        $("html, body").animate({
                            scrollTop: $('#vehicle-container').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('change', '#order_by_mobile-header',
        function (e) {
            $('.js-options-loader').fadeIn();
            var sort = $(this).val();
            var form = $("#pricing-filter-form-mobile");
            var pricingType = $('.pt-cookie.is-active').html();
            $.ajax(
                {
                    url: form.attr('action'),
                    data: {
                        "BodyType": $('.js-filter-radio[name="bodyType"]:checked').val(),
                        "SpecLevel": $('.js-filter-radio[name="specLevel"]:checked').val(),
                        "FuelType": $('.js-filter-radio[name="fuelType"]:checked').val(),
                        "Transmission": $('.js-filter-radio[name="transmission"]:checked').val(),
                        "Drive": $('.js-filter-radio[name="drive"]:checked').val(),
                        "PricingType": pricingType,
                        "Page": 1,
                        "SortBy": sort
                    },
                    type: "GET",
                    success: function (data) {
                        $("#vehicle-results").html(data);
                        swapPaymentTypes(pricingType);
                        $('#order_by_mobile').val(sort);
                        $("html, body").animate({
                            scrollTop: $('#vehicle-container').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('change', '.js-filter-select',
        function (e) {
            $('.js-options-loader').fadeIn();
            var form = $("#pricing-filter-form");
            var pricingType = $('.pt-cookie.is-active').html();
            $.ajax(
                {
                    url: form.attr('action'),
                    data: form.serialize() + "&PricingType=" + pricingType,
                    type: "GET",
                    success: function (data) {
                        $("#vehicle-results").html(data);
                        swapPaymentTypes(pricingType);
                        $("html, body").animate({
                            scrollTop: $('#vehicle-results').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', '.js-paginate-btn',
        function (e) {
            $('.js-options-loader').fadeIn();
            e.preventDefault();

            var pricingType = $('.pt-cookie.is-active').html();

            var form = $("#pricing-filter-form");
            var dataSent = (form.serialize() !== "" && form.serialize() !== "?" ? form.serialize() + "&PricingType=" : "?PricingType=") + pricingType + "&SortBy=" + $('#order_by_desktop').val() + "&Page=" + $(this).data('page');
            if (windowWidth <= 1216 && $("#pricing-filter-form-mobile:visible").length > 0) {
                form = $("#pricing-filter-form-mobile");
                dataSent = {
                    "BodyType": $('.js-filter-radio[name="bodyType"]:checked').val(),
                    "SpecLevel": $('.js-filter-radio[name="specLevel"]:checked').val(),
                    "FuelType": $('.js-filter-radio[name="fuelType"]:checked').val(),
                    "Transmission": $('.js-filter-radio[name="transmission"]:checked').val(),
                    "Drive": $('.js-filter-radio[name="drive"]:checked').val(),
                    "PricingType": pricingType,
                    "Page": $(this).data('page'),
                    "SortBy": $('#order_by_mobile').val()
                };
            }
            $.ajax(
                {
                    url: form.attr('action'),
                    data: dataSent,
                    type: "GET",
                    success: function (data) {
                        $("#vehicle-results").html(data);
                        $("html, body").animate({
                            scrollTop: $('#vehicle-container').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', '.js-close-active-popouts',
        function (e) {
            $('#vehicle-results').fadeIn();
        });
});